import { useDateTimeContext } from "@shared/utility/date-time-service/date-time.context";
import { GetBillingModel } from "@factory/model/query-model-billing";
import { billingFormDefault } from "./form.default";
import { BillingFormSchema } from "./form.rule";

export const useFormDefaultBilling = () => {
  const { formatDate } = useDateTimeContext();

  const getDefault = (cachedValue: GetBillingModel | undefined) => {
    return !cachedValue
      ? billingFormDefault
     : ({
        contract: cachedValue.contract,
        session: cachedValue.session,
      } as BillingFormSchema);
  };

  return {
    getDefault,
  };
};
